import { render } from "./GroupSectionIcon.vue?vue&type=template&id=02bf8d55"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__